export const SUPPORTED_INDUSTRIES = [
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'realEstate', label: 'Real Estate' },
  { value: 'technology', label: 'Technology' },
  { value: 'financeBanking', label: 'Finance & Banking' },
  { value: 'retail', label: 'Retail' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'legalServices', label: 'Legal Services' },
  { value: 'education', label: 'Education' },
  { value: 'nonProfit', label: 'Non-Profit Organizations' },
  { value: 'hospitalityTourism', label: 'Hospitality & Tourism' },
  { value: 'marketingAdvertising', label: 'Marketing & Advertising' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'governmentPublicSector', label: 'Government & Public Sector' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'construction', label: 'Construction' },
  { value: 'energyUtilities', label: 'Energy & Utilities' },
  { value: 'transportationLogistics', label: 'Transportation & Logistics' },
  { value: 'foodBeverage', label: 'Food & Beverage' },
  { value: 'pharmaceuticals', label: 'Pharmaceuticals' },
  { value: 'mediaEntertainment', label: 'Media & Entertainment' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'telecommunications', label: 'Telecommunications' },
  { value: 'aerospaceDefense', label: 'Aerospace & Defense' },
  { value: 'textilesApparel', label: 'Textiles & Apparel' },
  { value: 'healthFitness', label: 'Health & Fitness' },
  { value: 'eCommerce', label: 'E-commerce' },
  { value: 'environmentalServices', label: 'Environmental Services' },
  { value: 'sportsRecreation', label: 'Sports & Recreation' },
  { value: 'artsCrafts', label: 'Arts & Crafts' },
  { value: 'other', label: 'Other' },
];

const comparableIndustry = value => value
  .trim()
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]/g, '');

export function normalizeSupportedIndustry(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  const candidate = comparableIndustry(value);
  return SUPPORTED_INDUSTRIES.find(industry => (
    comparableIndustry(industry.value) === candidate
    || comparableIndustry(industry.label) === candidate
  ))?.value || '';
}

export function supportedIndustryLabel(value) {
  const normalized = normalizeSupportedIndustry(value);
  return SUPPORTED_INDUSTRIES.find(industry => industry.value === normalized)?.label || value;
}
